import * as THREE from 'three';
import * as marietta from '../../marietta';

export default class WalkThroughControl {
    /**
     * コントローラ以外でカメラアングルが変更されたとき
     * コントローラーにカメラアングルをセットする
    */
    public setCameraAngle: () => void;

    /**
     * 移動速度を設定
    */
    public setMoveSpeed: (speed: number) => void;

    /**
     * 移動速度を設定（タッチ時）
    */
    public setMoveSpeedForTouch: (speed: number) => void;

    /**
     * 回転速度を設定
    */
    public setRotSpeed: (speed: number) => void;

    /**
     * 移動速度を取得
    */
    public getMoveSpeed: () => number;

    /**
     * 移動速度を取得（タッチ時）
    */
    public getMoveSpeedForTouch: () => number;

    /**
     * 回転速度を取得
    */
    public getRotSpeed: () => number;

    /**
     * 衝突時の跳ね返りの大きさを設定
    */
    public setHitMargin: (val: number) => void;

    /**
     *
    */
    public setHitteHeightOfset: (val: number) => void;

    /**
     * マウスホイールの回転方向を設定
    */
    public setWheelReverse: (bool: boolean) => void;

    public padEnabled: () => boolean;

    public angleCorrection: () => boolean;

    public setAngleCorrection: (bool: boolean) => void;

    public showPad: (bool: any) => void;

    /**
     * 活性・非活性を設定
     * @ bool: boolean
     */
    public setEnabled: (bool: boolean) => void;
    public enabled: boolean = true;

    /**
     * 活性・非活性を取得
     */
    public getEnable: () => boolean;

    /**
     * カメラの高さを設定
     */
    public setCameraHeight: (y: number) => void;

    /**
     * 1フレーム前のカメラの位置を渡す
     */
    public setOldPosition: (x: number, y: number, z: number) => void;

    public btnControlSet: { [x: string]: () => void };

    public update: (target: THREE.Object3D, hitTarget: THREE.Mesh[]) => void;

    public resetAngle: () => void;

    public reset: () => void;

    public forward: () => void;

    public back: () => void;

    public stop: () => void;

    public resized: () => void;

    // エレメント
    private _el: HTMLElement;

    // カメラ
    private _camera: THREE.Object3D;

    private _cameraPosY: number;

    private _isMove: boolean = false;

    private _isSlide: boolean = false;

    private _isPan: boolean = false;

    private _angleChanged: boolean = false;

    private _clickTime: any = undefined;

    private _mouseX: number;

    private _mouseY: number;

    private _oldX: number;

    private _oldY: number;

    private _dispatcher: any;

    private q: THREE.Quaternion = new THREE.Quaternion();

    private axisX: THREE.Vector3 = new THREE.Vector3(1, 0, 0);

    private axisY: THREE.Vector3 = new THREE.Vector3(0, 1, 0);

    private axisZ: THREE.Vector3 = new THREE.Vector3(0, 0, 1);

    private angleX: number = 0;

    private angleY: number = 0;

    private _moveSpeed: number;

    private _moveSpeedForTouch: number;

    private _rotSpeed: number;

    private _accelRate = 1.0; // 1.01  // const

    // パン角度制限
    private upperAngleX: number = 60;

    private lowerAngleX: number = -60;

    private maxSpeed: number = 0.30; // to avoid penetration

    private maxSpeedForPad: number = 0.05;

    private maxSpeedForPadX: number = 0.20;

    private _padCtrlState: number = -1; // -1:Start, 0:None, 1:Move, 2:Rotate

    private _padCtrlMode: number = -1; // -1:SameAsPC. 0:MoveOrRotate, 1:JoyStickish

    private _padCenter: { x: number; y: number; } = { x: 0.0, y: 0.0 };

    private _moveStripWidth: number = 32;

    private _rotateStripHeight: number = 25;

    private _staircaseReg: RegExp = /:str/;

    private dxThres: number = 12;

    private rayPos: THREE.Vector3 = new THREE.Vector3(0, 0.5, 0);

    private hitter: THREE.Vector3 = new THREE.Vector3(0, 0, 0);

    private wallDir: THREE.Vector3 = new THREE.Vector3(0, 0, 0);

    private updownAngle: number = 20.0;

    private innerLevelAngle: number = -11.0;

    private outerLevelAngle: number = 0.0;

    private closeWallMargin: number = 1.2;

    private lastGap: number = 10;

    private lastGround: string = '';

    // 移動用
    private _speedY: number = 0;

    private _speedX: number = 0;

    private _rotAngle: number = 0;

    private _upAngle: number = 0;

    // 仰角等の修正モード.
    private _angleCorrection: boolean = true;

    private _wheelSpeed: any;

    private _wheelReverse: boolean = false;

    // 衝突判定用
    private _hitMargin: number = 0.5;

    private _hitteHeightOfset: number = 0;

    private _frontMoveEnabled: boolean = true;

    private _backMoveEnabled: boolean = true;

    private _leftMoveEnabled: boolean = true;

    private _rightMoveEnabled: boolean = true;

    private _pad: any;

    private _baseImg: any;

    private _padImg: any;

    private _padWidth: any;

    private _padHeight: any;

    private _padInitX: any;

    private _padInitY: any;

    private _padImage: any;

    private kaidanLow: any = 1.2;

    private squatLow: any = 0.6;

    constructor(camera: THREE.Object3D, domElement: HTMLElement, dispatcher: any) {
        const _this = this;
        this._camera = camera;
        this._cameraPosY = this._camera.position.y;
        this._dispatcher = dispatcher;
        this._el = domElement;
        this._moveSpeed = 1;
        this._moveSpeedForTouch = 0.5;
        this._rotSpeed = 1;
        const vec: THREE.Vector3 = new THREE.Vector3();
        const v2 = camera.getWorldDirection(vec);
        this.angleX = Math.atan2(v2.y, -v2.z);
        this.angleY = Math.atan2(-v2.x, -v2.z);

        // タッチイベント判定
        // 一旦タブレットモードに入らないようにする.
        if (marietta.view3d.base.Config.me.isTouchMode(this._el)) {
            // タッチ対応（スマホ・タブレット）
            this._el.style['-webkit-tap-highlight-color'] = 'rgba(0, 0, 0, 0)';
            // mouse
            this._el.addEventListener('touchstart', this.onPadTouchStart, { passive: false });
            this._el.addEventListener('touchend', this.onPadTouchEnd, { passive: false });
            // ctrl pad
            if (this._padCtrlMode >= 0) { // MoveOrRotate, JoyStickish modes
                this._pad = document.getElementById('ctrl_pad');
                const date = new Date();
                if (this._pad == null) {
                    this._pad = document.createElement('div');
                    this._pad.id = 'ctrl_pad';
                    this._baseImg = document.createElement('img');
                    this._baseImg.name = 'ctrl_base';
                    this._baseImg.alt = 'base';
                    this._baseImg.width = '180';
                    this._baseImg.height = '180';
                    this._baseImg.crossorigin = 'anonymous';
                    this._baseImg.src = `${marietta.view3d.webcad.View3dGlobal.shared.libsDir}base.png?ts=${date.getTime()}`;
                    this._baseImg.style['-webkit-touch-callout'] = 'none';
                    this._pad.appendChild(this._baseImg);
                    this._padImg = document.createElement('img');
                    this._padImg.id = 'pad';
                    this._padImg.name = 'pad';
                    this._padImg.alt = 'pad';
                    this._padImg.width = '42';
                    this._padImg.height = '42';
                    this._padImg.crossorigin = 'anonymous';
                    this._padImg.src = `${marietta.view3d.webcad.View3dGlobal.shared.libsDir}pad.png?ts=${date.getTime()}`;
                    this._padImg.style['-webkit-touch-callout'] = 'none';
                    this._pad.appendChild(this._padImg);
                    this._el.appendChild(this._pad);
                }
                if (this._pad !== null) {
                    this._padWidth = this._pad.clientWidth;
                    this._padHeight = this._pad.clientHeight;
                    this._padInitX = this._pad.offsetLeft;
                    this._padInitY = this._pad.offsetTop;
                    this._padImage = (document.images as any).pad;
                }
                this._el.addEventListener('touchstart', this.onTouchStart, { passive: false });
                this._el.addEventListener('touchend', this.onTouchEnd, { passive: false });
                this._pad.addEventListener('touchstart', this.onTouchCtrlStart, { passive: false });
                this._pad.addEventListener('touchend', this.onTouchCtrlEnd, { passive: false });
                this._pad.style.visibility = 'visible';
            }
            // keybord
            if (document.addEventListener) {
                document.addEventListener('keydown', this.onKeyDown);
                document.addEventListener('keyup', this.onKeyUp);
            } else if ((<any>this._el).attachEvent) {
                // アタッチイベントに対応している
                (<any>document).attachEvent('onkeydown', this.onKeyDown);
                (<any>document).attachEvent('onkeyup', this.onKeyUp);
            }
            if (this._pad !== undefined) this._pad.style.visibility = 'hidden';
            // document.getElementById( 'info' ).innerHTML = "<p>[ walkthrough control ] Move : VirturlPad Pan : Swipe Screen</p>";
        } else {
            // タッチ非対応（PC）
            // document.getElementById( 'info' ).innerHTML = "<p>[ walkthrough control ] Move : ↑ ↓ ← → Pan : AWSD</p>";
            // keybord
            if (document.addEventListener) {
                document.addEventListener('keydown', this.onKeyDown);
                document.addEventListener('keyup', this.onKeyUp);
            } else if ((<any>this._el).attachEvent) {
                // アタッチイベントに対応している
                (<any>document).attachEvent('onkeydown', this.onKeyDown);
                (<any>document).attachEvent('onkeyup', this.onKeyUp);
            }

            // mouse
            if (this._el.addEventListener) {
                this._el.addEventListener('mousedown', this.onMouseDown);
                document.addEventListener('mouseup', this.onMouseUp);
                this._el.addEventListener('mouseup', this.onMouseUp_);

                this._el.addEventListener('wheel', this.onMouseWheel);
                // this._el.addEventListener('mousewheel', this.onMouseWheel);
            } else if ((<any>this._el).attachEvent) {
                (<any>this._el).attachEvent('onmousedown', this.onMouseDown);
                (<any>document).attachEvent('onmouseup', this.onMouseUp);
                (<any>this._el).attachEvent('wheel', this.onMouseWheel);
                // (<any> this._el).attachEvent('onmousewheel', this.onMouseWheel);
            }
        }

        /*
        * public setter getter
        */
        this.setMoveSpeed = (speed) => { this._moveSpeed = speed; };
        this.setMoveSpeedForTouch = (speed) => { this._moveSpeedForTouch = speed; };
        this.setRotSpeed = (speed) => { this._rotSpeed = speed; };
        this.getMoveSpeed = () => this._moveSpeed;
        this.getMoveSpeedForTouch = () => this._moveSpeedForTouch;
        this.getRotSpeed = () => this._rotSpeed;
        this.setHitMargin = (val) => { this._hitMargin = val; };
        this.setHitteHeightOfset = (val) => { this._hitteHeightOfset = val; };
        this.setWheelReverse = (bool) => { this._wheelReverse = bool; };
        this.padEnabled = () => this._pad !== undefined;
        this.angleCorrection = () => this._angleCorrection;
        this.setAngleCorrection = (val) => { this._angleCorrection = val; };
        this.showPad = (value) => {
            if ((this._pad !== undefined) && (this._padImg !== undefined) && (this._baseImg !== undefined)) {
                if (value) {
                    this._pad.style.visibility = 'visible';
                    this._padImg.style.visibility = 'visible';
                    this._baseImg.style.visibility = 'visible';
                } else {
                    this._pad.style.visibility = 'hidden';
                    this._padImg.style.visibility = 'hidden';
                    this._baseImg.style.visibility = 'hidden';
                }
            }
        };


        this.setEnabled = (bool: boolean) => {
            this.enabled = bool;
        }

        /*
        * public reset
        */
        this.resetAngle = () => {
            this.q = new THREE.Quaternion();
            const _v2 = this._camera.getWorldDirection(new THREE.Vector3());
            this.angleX = Math.atan2(_v2.y, Math.sqrt(_v2.z * _v2.z + _v2.x * _v2.x));
            this.angleY = Math.atan2(-_v2.x, -_v2.z);
        };

        this.reset = () => {
            this._isMove = false;
            this._isSlide = false;
            this._isPan = false;
            this.resetAngle();
            this._speedY = 0;
            this._speedX = 0;
            this._rotAngle = 0;
            this._upAngle = 0;
            this._frontMoveEnabled = true;
            this._backMoveEnabled = true;
            this._leftMoveEnabled = true;
            this._rightMoveEnabled = true;
        };

        /*
        * public ボタンダウンで移動用
        */
        this.btnControlSet = {
            fwd() {
                _this._isMove = true;
                _this._speedY = _this._moveSpeed * 0.02;
            },
            back() {
                _this._isMove = true;
                _this._speedY = -_this._moveSpeed * 0.02;
            },
            panLeft() {
                _this._isPan = true;
                _this._upAngle = 0;
                _this._rotAngle = _this._rotSpeed * 0.25;
            },
            panRight() {
                _this._isPan = true;
                _this._upAngle = 0;
                _this._rotAngle = -_this._rotSpeed * 0.25;
            },
            stop() {
                _this._isMove = false;
                _this._speedY = 0;
                _this._isPan = false;
                _this._rotAngle = 0;
            },
        };
        this.forward = () => {
            this.btnControlSet.fwd();
        };
        this.back = () => {
            this.btnControlSet.back();
        };
        this.stop = () => {
            this.btnControlSet.stop();
        };

        /*
        * public update
        */
        this.update = (target, hitTarget) => {
            // 移動
            if (this._isMove) {
                this._speedY *= this._accelRate;
                this.move(this._speedY, target, hitTarget);
                this.checkWheel();
            }
            if (this._isSlide) {
                this._speedX *= this._accelRate;
                this.slide(this._speedX, target, hitTarget);
            }
            // パン
            if (this._isPan) {
                this._rotAngle *= this._accelRate;
                this.setQuaternion(this._upAngle, this._rotAngle);
            }
        };

        /*
        * public resized
        */
        this.resized = () => {
            this._padInitX = this._pad.offsetLeft;
            this._padInitY = this._pad.offsetTop;
        };

        /*
        * set move speed
        */
        this.setMoveSpeed = (speed) => {
            this._moveSpeed = speed;
        };
    }

    /*
    Math.abs 高速化
    */
    private static abs(a: any) {
        return a > 0 ? a : -a;
    }

    /**
    *
    * イベントハンドラ
    *
    */

    /*
    contrl pad
    仮想タッチパッド
    */

    public onTouchCtrlStart = (): void => {
        if ((this._pad !== null) && (this._padWidth <= 0)) { // とりなおす.
            this._padWidth = this._pad.clientWidth;
            this._padHeight = this._pad.clientHeight;
            this._padInitX = this._pad.offsetLeft;
            this._padInitY = this._pad.offsetTop;
            this._padImage = (document.images as any).pad;
            this._padCenter.x = this._padInitX + (this._padWidth / 2);
            this._padCenter.y = this._padInitY + (this._padHeight / 2);
        }

        this._padImage.style.visibility = 'hidden';
        this._padCtrlState = -1;
        this._pad.addEventListener('touchmove', this.onToucCtrlMove, { passive: false });
    }

    public onTouchCtrlEnd = (): void => {
        this._padImage.style.visibility = 'visible';
        this._padCtrlState = 0;
        this._pad.removeEventListener('touchmove', this.onToucCtrlMove);
        this._isMove = false;
        this._isSlide = false;
        this._isPan = false;
    }

    public getPadCtrlState = (x: any, y: any): number => {
        // const dx = Math.abs(x);
        // const dy = Math.abs(y);
        if (Math.abs(x) < this._moveStripWidth) return 1;
        if (Math.abs(y) < this._rotateStripHeight) return 2;
        return 0;
    }

    public onToucCtrlMove = (e: any): void => {
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        e.preventDefault();
        if (this._padCtrlMode === 0) { // MoveOrRotate mode
            const dx = e.changedTouches[0].pageX - this._padCenter.x;
            const dy = e.changedTouches[0].pageY - this._padCenter.y;
            if (this.getPadCtrlState(dx, dy) === 1) {
                this._padCtrlState = 1;
                this._isMove = true;
                this._speedY = -dy * 0.01 * this._moveSpeedForTouch;
            } else {
                this._isMove = false;
                this._speedY = 0.0;
            }
            this._isSlide = false;
            this._speedX = 0.0;
        } else if (this._padCtrlMode === 1) { // alternative (JOYSTICK mode)
            // const vx = e.changedTouches[0].pageX - this._padCenter.x;
            const vy = e.changedTouches[0].pageY - this._padCenter.y;
            this._isMove = true;
            this._speedY = -vy * 0.01 * this._moveSpeedForTouch;
            this._isSlide = false;
            this._speedX = 0.0;
        } else {
            // do nothing...
            return;
        }
        if (this._speedY > this.maxSpeedForPad) this._speedY = this.maxSpeedForPad;
        else if (this._speedY < -this.maxSpeedForPad) this._speedY = -this.maxSpeedForPad;
        if (this._speedX > this.maxSpeedForPadX) this._speedX = this.maxSpeedForPadX;
        else if (this._speedX < -this.maxSpeedForPadX) this._speedX = -this.maxSpeedForPadX;
    }

    /*
    touch
    151022 仮想タッチパッド導入によってパンのみに変更
    */
    public onTouchStart = (e: any): void => {
        this._oldX = e.changedTouches[0].pageX;
        this._oldY = e.changedTouches[0].pageY;
        this._mouseX = this._oldX;
        this._mouseY = this._oldY;
        // クリック判定に使う.
        this._angleChanged = false;
        this._clickTime = new Date();
        this._el.addEventListener('touchmove', this.onToucMove, { passive: false });
    }

    public onPadTouchStart = (e: any): void => {
        this._oldX = e.changedTouches[0].pageX;
        this._oldY = e.changedTouches[0].pageY;
        this._mouseX = this._oldX;
        this._mouseY = this._oldY;
        // クリック判定に使う.
        this._angleChanged = false;
        this._clickTime = new Date();
        this._el.addEventListener('touchmove', this.onPadToucMove, { passive: false });
    }

    public onTouchEnd = (e: any): void => {
        this._el.removeEventListener('touchmove', this.onToucMove);
        this._isMove = false;
        this._isSlide = false;
        this._isPan = false;
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        const now = new Date();
        if ((this._clickTime !== undefined) && !this._angleChanged && (now.getTime() - this._clickTime.getTime() < 500)/* 500 msec */) {
            this.checkClick(e);
        }
    }

    public onPadTouchEnd = (e: any): void => {
        this._el.removeEventListener('touchmove', this.onPadToucMove);
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        const now = new Date();
        if ((this._clickTime !== undefined) && !this._angleChanged && (now.getTime() - this._clickTime.getTime() < 500)/* 500 msec */) {
            this.checkClick(e);
        }
        if (this._dispatcher != null) {
            this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtEndEvent, <THREE.PerspectiveCamera>this._camera));
        }
    }

    public onToucMove = (e: any): void => {
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        e.preventDefault();
        let dx: number = 0;
        let dy: number = 0;
        if (this._padCtrlState !== 0) {
            if (this._padCtrlMode === 0) { // MoveOrRotate mode
                dx = e.changedTouches[0].pageX - this._padCenter.x;
                dy = e.changedTouches[0].pageY - this._padCenter.y;
                if (this.getPadCtrlState(dx, dy) === 2) {
                    this._padCtrlState = 2;
                    const sign = dx > 0.0 ? -1.0 : 1.0;
                    const angleX = 0.0;
                    const angleY = Math.sqrt(Math.abs(dx) - this._rotateStripHeight) * 0.13 * this._rotSpeed * sign;
                    this.setQuaternion(angleX, angleY);
                }
            } else if (this._padCtrlMode === 1) { // alternative (JOYSTICK mode)
                this._mouseX = e.changedTouches[0].pageX;
                // use average with _oldX as start point, to moderate value change.
                dx = this._mouseX - (this._oldX + this._padCenter.x) / 2;
                const angleX = 0.0;
                let angleY = 0.0;
                if ((dx <= -this.dxThres) || (this.dxThres <= dx)) {
                    const sign = dx > 0.0 ? -1.0 : 1.0;
                    angleY = Math.sqrt(Math.abs(dx - this.dxThres)) * 0.13 * this._rotSpeed * sign;
                }
                this.setQuaternion(angleX, angleY);
            } else {
                // do nothing.
            }
        } else {
            this._mouseX = e.changedTouches[0].pageX;
            this._mouseY = e.changedTouches[0].pageY;
            dx = this._mouseX - this._oldX;
            dy = this._mouseY - this._oldY;
            //
            const angleX = (dy * 0.1) * this._rotSpeed * 0.3;
            const angleY = (dx * 0.1) * this._rotSpeed * 0.3;
            this.setQuaternion(angleX, angleY);
        }
        this._oldX = this._mouseX;
        this._oldY = this._mouseY;
    }

    public onPadToucMove = (e: any): void => {
        e.preventDefault();
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        this._mouseX = e.changedTouches[0].pageX;
        this._mouseY = e.changedTouches[0].pageY;
        const dx = this._mouseX - this._oldX;
        const dy = this._mouseY - this._oldY;
        const angleX = (dy * 0.05) * this._rotSpeed;
        const angleY = (dx * 0.05) * this._rotSpeed;
        // rotate
        this.setQuaternion(angleX, angleY);
        //
        this._oldX = this._mouseX;
        this._oldY = this._mouseY;
        this._angleChanged = (angleX !== 0) || (angleY !== 0);
    }

    /*
    keybord
    */
    public onKeyDown = (e: any): void => {
        if (!this.enabled) return;
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        // キーコード
        const keycode = e.keyCode;
        // 前後移動
        if (!this._isMove) {
            if (keycode === 38) { // up
                this._isMove = true;
                this._speedY = 0.02 * this._moveSpeed;
            }
            if (keycode === 40) { // down
                this._isMove = true;
                this._speedY = -0.02 * this._moveSpeed;
            }
        }
        // 矢印キー横はカメラパンに変更
        if (!this._isPan) {
            if (keycode === 39) { // right
                this._isPan = true;
                this._upAngle = 0;
                this._rotAngle = -0.25 * this._rotSpeed;
            }
            if (keycode === 37) { // left
                this._isPan = true;
                this._upAngle = 0;
                this._rotAngle = 0.25 * this._rotSpeed;
            }
        }
        // 上下パン
        if (!this._isPan) {
            if (keycode === 83) { // W
                this._isPan = true;
                this._upAngle = -0.25 * this._rotSpeed;
                this._rotAngle = 0;
            }
            if (keycode === 87) { // S
                this._isPan = true;
                this._upAngle = 0.25 * this._rotSpeed;
                this._rotAngle = 0;
            }
        }
        // AD キーは横移動に変更
        if (!this._isSlide) {
            if (keycode === 68) { // A
                this._isSlide = true;
                this._speedX = -0.02 * this._moveSpeed;
            }
            if (keycode === 65) { // D
                this._isSlide = true;
                this._speedX = 0.02 * this._moveSpeed;
            }
        }
        if (this._dispatcher != null) {
            this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtKeyEvent, keycode));
        }
    }

    public onKeyUp = (): void => {
        if (!this.enabled) return;
        if (this._isMove || this._isSlide || this._isPan) {
            if (this._dispatcher != null) {
                this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtEndEvent, <THREE.PerspectiveCamera>this._camera));
            }
        }

        this._isMove = false;
        this._isSlide = false;
        this._isPan = false;
    }

    /*
    TODO: mouse
    */
    public onMouseDown = (e: any): void => {
        if (!this.enabled) return;
        this._oldX = e.clientX;
        this._oldY = e.clientY;
        this._mouseX = this._oldX;
        this._mouseY = this._oldY;
        // クリック判定に使う.
        this._angleChanged = false;
        this._clickTime = new Date();
        // カーソルアイコン切り替え
        // 内観かつ選択モード時
        if (!marietta.webcad.WebCADGlobal.isViewCameraMode && (document.querySelector('.wtCamSet') as HTMLElement).style.display !== 'none') {
            // カーソルを通常のカーソルする
            // $('#webcad3dView').css('cursor', 'auto');
            document.getElementById('webcad3dView').style.cursor = 'auto';
        } else { // ビューモード時
            // カーソルを手のマークにする
            // $('#webcad3dView').css('cursor', `url(${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/grabbing.cur), move`);
            document.getElementById('webcad3dView').style.cursor = `url(${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/grabbing.cur), move`;
        }
        document.addEventListener('mousemove', this.onMouseMove);

        if (this._dispatcher != null) {
            this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtMouseDown, <THREE.PerspectiveCamera>this._camera));
        }
    }

    public onMouseUp = (e: any): void => {
        document.removeEventListener('mousemove', this.onMouseMove);
        // カーソルアイコン切り替え
        // 内観かつ選択モード時
        if (!marietta.webcad.WebCADGlobal.isViewCameraMode && (document.querySelector('.wtCamSet') as HTMLElement).style.display !== 'none') {
            // カーソルを通常のカーソルする
            // $('#webcad3dView').css('cursor', 'auto');
            document.getElementById('webcad3dView').style.cursor = 'auto';
        } else { // ビューモード時
            // カーソルを手のマークにする
            // $('#webcad3dView').css('cursor', `url(${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/grab.cur), move`);
            document.getElementById('webcad3dView').style.cursor = `url(${marietta.webcad.WebCADGlobal.webcad2Dmanager.assets_url}img/grab.cur), move`;
        }
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        const now = new Date();
        if ((this._clickTime !== undefined) && !this._angleChanged && (now.getTime() - this._clickTime.getTime() < 500)/* 500 msec */) {
            this.checkClick(e);
        }

        // if (this._dispatcher != null) {
        //     this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtEndEvent, <THREE.PerspectiveCamera>this._camera));
        // }
    }

    private onMouseUp_ = (e: any): void => {
        if ((this._camera === undefined) || !this._camera.visible) return;

        // onMouseUpで以下の処理を入れると関係ないところをクリックしても呼び出されるので
        if (this._dispatcher != null) {
            this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtEndEvent, <THREE.PerspectiveCamera>this._camera));
        }
    }

    public onMouseMove = (e: any): void => {
        e.preventDefault();
        if (!this.enabled) return;
        if ((this._camera === undefined) || !this._camera.visible) return;      // カメラが無効の時は何もしない

        this._mouseX = e.clientX;
        this._mouseY = e.clientY;
        const dx = this._mouseX - this._oldX;
        const dy = this._mouseY - this._oldY;
        const angleX = (dy * 0.05) * this._rotSpeed;
        const angleY = (dx * 0.05) * this._rotSpeed;
        // rotate
        this.setQuaternion(angleX, angleY);
        this._oldX = this._mouseX;
        this._oldY = this._mouseY;
        this._angleChanged = (angleX !== 0) || (angleY !== 0);
    }

    public checkClick = (e: any): void => {
        if (this._dispatcher === undefined) return;

        const rect = e.target.getBoundingClientRect();
        const x = ((e.clientX - rect.left) / (rect.right - rect.left)) * 2 - 1;
        const y = -((e.clientY - rect.top) / (rect.bottom - rect.top)) * 2 + 1;

        const vector = new THREE.Vector3(x, y, 1);
        vector.unproject(<any>this._camera);
        vector.sub(this._camera.position).normalize();
        const ray: THREE.Raycaster = new THREE.Raycaster(this._camera.position, vector);
        const targets = marietta.view3d.webcad.View3dGlobal.shared.getTargetObjects(9);
        const objs = ray.intersectObjects(targets, true);
        if (objs.length > 0) this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtObjectClicked, objs));
    }

    _pastWheelSpeed: number = 0;

    _wheelEnabled: boolean = false;

    public onMouseWheel = (e: any): void => {
        if (!this.enabled) return;
        if ((this._camera === undefined) || !this._camera.visible) return;          // カメラが無効の時は何もしない

        e.preventDefault();
        this._wheelEnabled = true;
        this._wheelSpeed = e.wheelDelta;
        this._speedY = -(this._wheelSpeed * 0.001) * this._moveSpeed;
        // ホイール逆回転
        if (this._wheelReverse) {
            this._speedY *= -1;
        }
        // 移動
        if (this._speedY > this.maxSpeed) this._speedY = this.maxSpeed;
        else if (this._speedY < -this.maxSpeed) this._speedY = -this.maxSpeed;
        this._isMove = true;
        this._pastWheelSpeed = this._wheelSpeed;

        if (this._dispatcher != null) {
            this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtWheelEvent, <THREE.PerspectiveCamera>this._camera));
        }
    }

    public checkWheel = (): void => {
        if (this._wheelEnabled && this._pastWheelSpeed === this._wheelSpeed) {
            this._wheelEnabled = false;
            this._isMove = this._wheelEnabled;
        }
    }

    public onMouseCtrlDown = (): void => {
        this._pad.addEventListener('mousemove', this.onMouseCtrlMove);
    }

    public onMouseCtrlUp = (): void => {
        this._pad.removeEventListener('mousemove', this.onMouseCtrlMove);
        this._isMove = false;
        this._isSlide = false;
        this._isPan = false;
    }

    private onMouseCtrlMove = (e: any): void => {
        // カメラが無効の時は何もしない
        if ((this._camera === undefined) || !this._camera.visible) return;
        e.preventDefault();
        const vx = e.clientX - (this._padInitX + (this._padWidth / 2));
        const vy = e.clientY - (this._padInitY + (this._padHeight / 2));
        this._isMove = true;
        this._speedY = -vy * 0.01 * this._moveSpeedForTouch;
        this._isSlide = true;
        this._speedX = -vx * 0.01 * this._moveSpeedForTouch;
    }

    /**
    *
    * カメラ制御関数
    *
    */
    /*
    カメラ上下左右パン
    rotation @ param = camera X angle, camera Y angle
    */
    private setQuaternion = (angX: number, angY: number): void => {
        if (!this.enabled) return;
        if (this._camera == null) return;

        this.angleX += THREE.MathUtils.degToRad(angX);
        if (this.angleX < THREE.MathUtils.degToRad(this.lowerAngleX)) {
            this.angleX = THREE.MathUtils.degToRad(this.lowerAngleX);
        }
        if (this.angleX > THREE.MathUtils.degToRad(this.upperAngleX)) {
            this.angleX = THREE.MathUtils.degToRad(this.upperAngleX);
        }
        // console.log("setQuaternion: angleX=" + angleX);
        const q1: THREE.Quaternion = new THREE.Quaternion();
        q1.setFromAxisAngle(this.axisX, this.angleX);
        this.angleY += THREE.MathUtils.degToRad(angY);
        const q2: THREE.Quaternion = new THREE.Quaternion();
        q2.setFromAxisAngle(this.axisY, this.angleY);
        this.q.multiplyQuaternions(q2, q1);
        this._camera.quaternion.copy(this.q);
        if (this._dispatcher !== undefined) {
            this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtAngleChanged, this._wheelEnabled));
        }
    }

    private getHitWall(hitter: any, dir: THREE.Vector3, target: any) {

        // Check left & right sides first.

        let dist = this.closeWallMargin;
        let hit;

        const getHitName = (obj: any): string => {
            if ((obj.parent != null) && (obj.parent.name != null)) return ''
            return obj.parent.name;
        }

        const matchName = /^(?=.*rom)(?=.*wall)|^(?=.*rom)(?=.*kosi)|^(?=.*out)(?=.*wall)|^(?=.*out)(?=.*kosi)/;

        const intersection = (direction: THREE.Vector3) => {
            const ray = new THREE.Raycaster(hitter, direction);
            const intersectObjects: THREE.Intersection[] = ray.intersectObjects(target);
            if (intersectObjects.length == 0) return;

            const object = intersectObjects[0];
            if (object.distance < dist && getHitName(object.object).match(matchName)) {
                hit = object;
                hit.normal = object.face.normal;
                dist = object.distance;
            }
        }

        intersection(dir.clone().applyAxisAngle(this.axisY, Math.PI / 2));
        intersection(dir.clone().applyAxisAngle(this.axisY, -Math.PI / 2));
        intersection(dir);
        return hit;
    }

    /*
    前後の移動
    move @param = move speed
    */

    private _cameraOldPosition: THREE.Vector3;

    public move(_speed: any, target: any, hitTarget: any) {
        if (!this.enabled) return;
        if (this._camera == null) return;

        const ray = new THREE.Raycaster(this.hitter, this._camera.getWorldDirection(new THREE.Vector3()));
        const objs: THREE.Intersection[] = ray.intersectObjects(hitTarget);

        let speed = _speed;

        if (objs.length > 0 && objs[0].distance < (this.isStairStep(objs[0]) ? 0 : this._hitMargin) + speed) {
            speed = (objs[0].distance - (this.isStairStep(objs[0]) ? 0 : this._hitMargin)) * 0.8;
        }

        const previousePosition = this._camera.position.clone();
        this._camera.translateOnAxis(this.axisZ, -speed); // ここ動く.
        this._camera.position.y = previousePosition.y;
        const s = WalkThroughControl.abs(speed * 0.1);
        this.limitter2(previousePosition, this._camera.position); // 動けない方向に移動した場合、押しもどす.
        const hitname = this.hitTest(target, hitTarget, s); // 前後左右下の衝突判定.

        if (hitname.match(/terrain/) && this.lastGround.match(/str/)) {
            this._camera.position.set(previousePosition.x, previousePosition.y, previousePosition.z)
        } else {
            this.lastGround = hitname;
        }

        if (this._angleCorrection == false) return;

        // 仰角俯角の調整.
        const direction = this._camera.getWorldDirection(new THREE.Vector3()).normalize();
        const vcurrent = THREE.MathUtils.radToDeg(Math.atan2(direction.y, Math.sqrt(direction.x * direction.x + direction.z * direction.z)));
        let vgoal = this.innerLevelAngle;
        let vdivision = 0.8;
        if (hitname.match(this._staircaseReg)) {
            this._camera.getWorldPosition(this.rayPos);
            this.rayPos.y -= this.kaidanLow; // 足元.
            const dir = direction.clone(); dir.y = 0.0;
            const _ray = new THREE.Raycaster(this.rayPos, dir);
            const hits: THREE.Intersection[] = _ray.intersectObjects(target);
            vgoal = ((hits.length > 0) && this.getObjPath(hits[0].object).match(this._staircaseReg)) ? this.updownAngle : -this.updownAngle - 15;
            vdivision = 6.0;
        } else if (hitname.match(/entrance/)) {
            vdivision = 0.5;
        } else if ((hitname === '') || hitname.match(/site|porch/)) {
            vgoal = this.outerLevelAngle;
        }
        const vstep = Math.max(1.0, Math.abs(vcurrent - vgoal) / vdivision);
        const vnext = vcurrent + (vgoal - vcurrent) / vstep;

        // 方位角の調整.
        let hcurrent = THREE.MathUtils.radToDeg(Math.acos(direction.dot(this.axisZ)));
        if (direction.x < 0) hcurrent = -hcurrent;
        let hgoal = hcurrent;
        let hnext = hcurrent;
        if (!this._leftMoveEnabled || !this._rightMoveEnabled || !this._frontMoveEnabled || !this._backMoveEnabled) {
            let dir = direction.clone(); dir.y = 0.0;
            const hit = this.getHitWall(this.hitter, dir, target);
            if (hit !== undefined) {
                const dot = dir.normalize().dot(hit.face.normal);
                if ((dot >= -1.0) && (dot <= 0.0)) {
                    if (((dot < -0.999999) || (dot >= 0.0)) && (hit.normal !== undefined)) {
                        dir = hit.normal;
                    }
                    this.wallDir.crossVectors(hit.face.normal, this.axisY).normalize();
                    if (this.wallDir.dot(dir) < 0) this.wallDir.negate();
                    hgoal = THREE.MathUtils.radToDeg(Math.acos(this.wallDir.dot(this.axisZ)));
                    if (this.wallDir.x < 0) hgoal = -hgoal;
                    if (hcurrent * hgoal < 0) {
                        if (hcurrent < 0) hcurrent = 360 + hcurrent;
                        else hgoal = 360 + hgoal;
                    }
                    if (Math.abs(hcurrent - hgoal) < this.lastGap) hnext = hgoal;
                    else hnext = ((((hgoal + hcurrent) / 2.0 + hcurrent) / 2.0 + hcurrent) / 2.0 + hcurrent) / 2.0;
                }
            }
        }
        this.setQuaternion(vnext - vcurrent, hnext - hcurrent);
    }

    /*
    左右の移動
    slide @param = move speed
    */
    private slide(speed: number, target: any, hitTarget: any) {
        if (this._camera == null) return;

        this._camera.translateOnAxis(this.axisX, -speed); // ここで動く.
        const s = WalkThroughControl.abs(speed * 0.1);
        this.limitter(s);
        this.hitTest(target, hitTarget, s);
    }

    /*
    リミッタ
    */
    private limitter(margin: any) {
        if (!this._frontMoveEnabled) {
            this._camera.position.z = this._cameraOldPosition.z + margin
        };
        if (!this._backMoveEnabled) {
            this._camera.position.z = this._cameraOldPosition.z - margin
        };
        if (!this._leftMoveEnabled) {
            this._camera.position.x = this._cameraOldPosition.x + margin
        };
        if (!this._rightMoveEnabled) {
            this._camera.position.x = this._cameraOldPosition.z - margin
        };
        this._cameraOldPosition = this._camera.position.clone();
    }

    /*
    リミッタ2
    */
    private limitter2(previousePosition: THREE.Vector3, currentPosition: THREE.Vector3): void {
        if ((previousePosition.x > currentPosition.x) && !this._leftMoveEnabled) {
            this._camera.position.x = previousePosition.x;
        }
        else if ((previousePosition.x < currentPosition.x) && !this._rightMoveEnabled) {
            this._camera.position.x = previousePosition.x;
        }
        if ((previousePosition.z > currentPosition.z) && !this._frontMoveEnabled) {
            this._camera.position.z = previousePosition.z;
        }
        else if ((previousePosition.z < currentPosition.z) && !this._backMoveEnabled) {
            this._camera.position.z = previousePosition.z
        }
        this._cameraOldPosition = this._camera.position.clone();
    }

    public getObjPath(obj: any, name?: any): string {
        let result = '';
        const _name = obj.objectId || obj.name;
        if (!_name) {
            if (name) {
                result = `${name}:${_name}`;
            } else {
                result = _name;
            }
        }
        if (obj.parent != null) return this.getObjPath(obj.parent, result);
        return result;
    }

    private static getMaterialIndex(geometry: any, index: any) {
        if (geometry.groups !== undefined) {
            for (let i = 0; i < geometry.groups.length; i += 1) {
                if ((geometry.groups[i].start <= index) && (index < geometry.groups[i].start + geometry.groups[i].count)) { return geometry.groups[i].materialIndex; }
            }
        }
        return 0;
    }

    private isStairStep(obj: any): boolean {
        if (!this.getObjPath(obj.object).match(this._staircaseReg)) return false;

        let matName = '';
        let matIndex = obj.face.materialIndex; // 正しくないmaterialIndexを返している.
        if (Array.isArray(obj.object.material)) {
            if (obj.object.geometry instanceof THREE.BufferGeometry) {
                matIndex = WalkThroughControl.getMaterialIndex(obj.object.geometry, obj.faceIndex);
            }
            if (matIndex < obj.object.material.length) {
                matName = obj.object.material[matIndex].name;
            }
        } else if (obj.face.materialIndex === 0) {
            matName = obj.object.material.name;
        }
        if (matName.match(/rom/)) { return false; }
        return true;
    }

    /*
    * カメラへのアタリ判定（RayCast）
    */
    public hitTest(target: any, hitTarget: any, _speed: any, _pushBack?: any): string {
        // const log = false;
        let hitname = '';
        let dist: any;

        let speed = _speed;
        let pushBack = _pushBack;

        if (speed === undefined) speed = WalkThroughControl.abs(this._speedY * 0.1); // set max to 0.1 to avoid IE wall penetration problem.
        if (pushBack === undefined) pushBack = true;

        // 上下方向アタリ判定
        {
            const rayposition = new THREE.Vector3(this._camera.position.x, this._camera.position.y - this.squatLow, this._camera.position.z);
            //   this.rayPos.set(this._camera.position.x, this._camera.position.y - this.squatLow, this._camera.position.z);
            let rayY = new THREE.Raycaster(rayposition, new THREE.Vector3(0, -1, 0));
            let objsY: THREE.Intersection[] = rayY.intersectObjects(target);
            let objY;
            const maxStepV = 0.7; // 70cm.
            // let obj_e;
            for (let i = 0; i < objsY.length; i += 1) {
                // 不可視のものにはヒットしない.
                if (objsY[i].object.visible && objsY[i].object.parent.visible) {
                    objY = objsY[i];
                    break;
                }
            }
            // 下方にヒットあり.
            if (objY !== undefined) {
                hitname = this.getObjPath(objY.object);
                dist = objY.distance + this.squatLow;
                let ofset = 0;
                // ヒット面と_cameraPosY カメラ高さの差. ofset<0(dist<_cameraPosY)だと上移動.
                if (dist >= 0) ofset = dist - this._cameraPosY;
                else ofset = -this._cameraPosY - dist;
                // デフォルト高さより高く、1m 以上落下する場合.
                if (ofset > 1.0) {
                    if (!this.lastGround.match(/str/)) {
                        /* ugly patch for webcad-1973 */
                        this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtFalling, this._camera.position.y - ofset));
                    }
                    return hitname;
                }
                // 合理的な距離の上下移動 maxStepV以下の場合.
                if (Math.abs(ofset) <= maxStepV) {
                    // デフォルト高さより高い.
                    if (this._camera.position.y >= this._cameraPosY) this._camera.position.y -= ofset;
                    // デフォルト高さより低い.
                    else this._camera.position.y = this._cameraPosY; // デフォルトの目線に.
                } else if (pushBack && (this._cameraOldPosition !== undefined)) {
                    // 以前のカメラ位置に戻す.
                    this._camera.position.set(this._cameraOldPosition.x, this._cameraOldPosition.y, this._cameraOldPosition.z);
                }
                // 位置の変更を通知.
                if (this._dispatcher !== undefined) {
                    this._dispatcher.dispatchEvent(new marietta.view3d.base.events.Event(marietta.view3d.base.defines.EventNames.wtPointChanged, objY.point));
                }
            }
            // 低い天井突き抜け対策
            this.rayPos.set(this._camera.position.x, this._camera.position.y - this.squatLow, this._camera.position.z);
            rayY = new THREE.Raycaster(this.rayPos, new THREE.Vector3(0, 1, 0));
            objsY = rayY.intersectObjects(target);
            objY = undefined;
            // obj_e = undefined;
            for (let i = 0; i < objsY.length; i += 1) {
                // 不可視のものにはヒットしない.
                if (objsY[i].object.visible && objsY[i].object.parent.visible) {
                    objY = objsY[i];
                    break;
                }
            }
            // 上方にヒットあり.
            if (objY !== undefined) {
                dist = objY.distance - this.squatLow;
                // ヒット面<_cameraPosY カメラ高さの場合、カメラ高さをヒット面レベルに下げる.
                if (dist < 0) {
                    this._camera.position.y += (dist - 0.05);
                }
            }
        }
        this.hitter.set(this._camera.position.x, this._camera.position.y + this._hitteHeightOfset, this._camera.position.z);

        // directiuon方向アタリ判定
        const intersection = (directiuon: THREE.Vector3) => {
            const ray = new THREE.Raycaster(this.hitter, directiuon);
            const objects: THREE.Intersection[] = ray.intersectObjects(hitTarget);
            let result = true;
            if (objects.length > 0) {
                result = (objects[0].distance >= (this.isStairStep(objects[0]) ? 0 : this._hitMargin) + speed);
            }
            return result;
        }

        // 前後左右の当たり判定
        this._frontMoveEnabled = intersection(new THREE.Vector3(0, 0, -1));
        this._backMoveEnabled = intersection(new THREE.Vector3(0, 0, 1));
        this._leftMoveEnabled = intersection(new THREE.Vector3(-1, 0, 0));
        this._rightMoveEnabled = intersection(new THREE.Vector3(1, 0, 0));

        return hitname;
    }
}
